import {ChannelType} from "../../../../Types/ChannelType";
import {
    getMinimumOrderQuantity,
    isMinimumOrderQuantityApplicable
} from "../../../ProductsList/MinimumOrderQuantity/getMinimumOrderQuantity";
import {CartProduct} from "../types";

export type OrderQuantityCalculation = {
    calculatedQuantity: number | string;
    hasMinimumOrderQuantityAdjustment: boolean;
    quantityInPieces: number | null;
};

export function calculateOrderQuantity(
    quantity: number | string,
    product: CartProduct,
    channel: ChannelType | null
): OrderQuantityCalculation {
    const requestedQuantity = Number(quantity);

    if (!Number.isFinite(requestedQuantity) || requestedQuantity <= 0) {
        return {
            calculatedQuantity: '',
            hasMinimumOrderQuantityAdjustment: false,
            quantityInPieces: null
        };
    }

    const allowsIncompletePackaging = channel?.IncompletePackaging === true
        && !channel.products.some((channelProduct) => channelProduct.id === product.id);
    const quantityPackage = Math.max(product.quantityPackage, 1);
    const minimumOrderQuantityApplies = isMinimumOrderQuantityApplicable(product, channel);
    const minimumOrderQuantity = minimumOrderQuantityApplies
        ? getMinimumOrderQuantity(product, channel) ?? 0
        : 0;
    const quantityWithoutMinimumOrderQuantity = allowsIncompletePackaging
        ? requestedQuantity
        : Math.round(requestedQuantity * quantityPackage);
    const quantityAfterMinimumOrderQuantity = Math.max(
        quantityWithoutMinimumOrderQuantity,
        minimumOrderQuantity
    );
    const calculatedQuantity = allowsIncompletePackaging
        ? quantityAfterMinimumOrderQuantity
        : Math.ceil(quantityAfterMinimumOrderQuantity / quantityPackage) * quantityPackage;

    return {
        calculatedQuantity: `${calculatedQuantity} ${product.unit}`,
        hasMinimumOrderQuantityAdjustment: minimumOrderQuantityApplies
            && calculatedQuantity !== quantityWithoutMinimumOrderQuantity,
        quantityInPieces: calculatedQuantity
    };
}
